/**
 * Currently, only the English wordlist is used. Other wordlists may be added later.
 */
import ENGLISH_WORDLIST from '../wordlists/english.json';

export { ENGLISH_WORDLIST };
